import { FC } from 'react'
import { Typography } from 'antd'
import { ThunderboltOutlined } from '@ant-design/icons'
import { useThemeStore } from '../../stores/themeStore'
import './UnderDevelopment.css'

const { Title, Text } = Typography

interface UnderDevelopmentProps {
  title?: string
  description?: string
}

/**
 * 功能开发中页面组件
 * - 玻璃拟态风格（glassmorphism）
 * - 多层动画效果（旋转 + 脉动）
 * - 支持深色/浅色主题
 * - 响应式设计
 */
const UnderDevelopment: FC<UnderDevelopmentProps> = ({
  title = '功能开发中',
  description = '功能开发中...',
}) => {
  const { theme } = useThemeStore()

  return (
    <div className="under-development-container">
      <div className={`under-development-card ${theme === 'dark' ? 'dark' : 'light'}`}>
        {/* 动态图标区域 */}
        <div className="icon-wrapper">
          {/* 外圈旋转动画 */}
          <div className="rotating-ring outer-ring" />
          <div className="rotating-ring middle-ring" />

          {/* 中心图标 - 脉动效果 */}
          <div className="icon-pulse">
            <ThunderboltOutlined className="thunder-icon" />
          </div>

          {/* 内圈反向旋转 */}
          <div className="rotating-ring inner-ring" />
        </div>

        {/* 文字内容 */}
        <div className="content">
          <Title level={3} className="title">
            {title}
          </Title>
          <Text className="description">{description}</Text>
        </div>

        {/* 底部装饰点 */}
        <div className="dots">
          <span className="dot" />
          <span className="dot" />
          <span className="dot" />
        </div>
      </div>
    </div>
  )
}

export default UnderDevelopment
